import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';

import logo from '../../assets/images/iChocChipLogo.png';

// const pages = ['Apps', 'Tech Stack', 'About us', 'Contact'];
const pages = [
  { name: 'Apps', link: '/apps' }, 
  { name: 'Tech Stack', link: '/tech-stack' }, 
  { name: 'About us', link: '/about' }, 
  { name: 'Contact us', link: '/contact'}
]

const Navbar: React.FC = () => {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const navigateTo = (link: string) => {
    handleCloseNavMenu();
    window.location.href = link;
  };

  return (
    <AppBar
      position="static"
      elevation={2}
      sx={{
        backgroundColor: '#ffffff',
        color: '#1a1a1a',
        borderBottom: '1px solid #e0e0e0',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>

          {/* Logo for desktop */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', mr: 2 }}>
            <img src={logo} alt="ChocChip Logo" style={{ height: 80, marginRight: 8 }} />
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                fontFamily: 'Carter One, sans-serif',
                fontWeight: 700,
                fontSize: '1.25rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              ChocChip Studios
            </Typography>
          </Box>

          {/* Mobile menu icon */}
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="open menu"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page.name}
                  onClick={() => {navigateTo(page.link)}}
                  sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}
                >
                  <Typography sx={{ textAlign: 'center', color: '#333' }}>{page.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* Mobile logo */}
          <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', flexGrow: 1 }}>
            <img src={logo} alt="ChocChip Logo" style={{ height: 36, marginRight: 8 }} />
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                fontFamily: 'Carter One, sans-serif',
                fontWeight: 700,
                fontSize: '1.15rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              ChocChip Studios
            </Typography>
          </Box>

          {/* Desktop nav buttons */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page.name}
                onClick={handleCloseNavMenu}
                sx={{
                  my: 2,
                  color: '#333',
                  display: 'block',
                  fontWeight: 500,
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
                href={page.link}
              >
                {page.name}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
